import { CartAvailablePromotion } from "@/modules/cart";
import OfferIcon from "atoms/icon/icons/ic_offers_ol.svg";
import { ActionModal } from "molecules/modal-window/action-modal/ActionModal";

type BuyXGetYCheckoutModalProps = {
  promotionText: string;
  open: boolean;
  onClose: () => void;
  onFirstButtonClick: () => void;
  onSecondButtonClick: () => void;
};

export const BuyXGetYCheckoutModal = (props: BuyXGetYCheckoutModalProps) => {
  return (
    <ActionModal
      open={props.open}
      onClose={props.onClose}
      headerIconSvg={OfferIcon}
      title="Don't miss out on our special promo!"
      firstButtonLabel="Add to cart"
      singleLineDoubleButton={true}
      onFirstButtonClick={props.onFirstButtonClick}
      secondButtonLabel="Checkout"
      onSecondButtonClick={props.onSecondButtonClick}
      useAnimatedBackground={true}
      description={
        <div className="pb-12">
          <CartAvailablePromotion
            title={props.promotionText}
            isReward={false}
            isMembership={false}
          />
        </div>
      }
      size="small"
    />
  );
};
